import React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import './leftnavlinks.css';

const LeftNavLinks = ({ icon, title, onClick, isSelected, collapsed, badgeCount, className }) => {
  return (
    <div
      className={`LeftNavLinks ${isSelected ? 'selected' : ''} ${className || ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onClick?.(e);
      }}
    >
      <div className='LeftNavLinks-icon'>
        <HugeiconsIcon icon={icon} color='currentColor' size={18} />
      </div>
      <div className='LeftNavLinks-title'>
        {!collapsed && <p>{title}</p>}
      </div>
      {!collapsed && badgeCount > 0 && (
          <div className="badge-count">{badgeCount}</div>
      )}
    </div>
  );
};

export default LeftNavLinks;